import { z } from "zod";

export type NotifyMyselfResponse = z.infer<typeof NotifyMyselfResponseSchema>;
export const NotifyMyselfResponseSchema = z.object({
  event_type: z.string(),
  event_value: z.array(z.string()),
  user_access_id: z.string(),
});
